const INDICATION_LABELS: Record<string, string> = {
  'gn-sepsis': 'Gram-Negative Sepsis',
  'complicated-uti': 'Complicated UTI',
  'pyelonephritis': 'Pyelonephritis',
  'intra-abdominal': 'Intra-Abdominal',
  'pneumonia-hap': 'Pneumonia (HAP)',
  'endocarditis-synergy': 'Endocarditis (Synergy)',
  'bacteremia': 'Bacteremia',
  'meningitis': 'Meningitis',
  'febrile-neutropenia': 'Febrile Neutropenia',
  'other': 'Other',
};

const FLUID_LABELS: Record<string, string> = {
  'euvolemic': 'Euvolemic',
  'hypervolemic': 'Hypervolemic',
  'hypovolemic': 'Hypovolemic',
};

const POPULATION_LABELS: Record<string, string> = {
  'standard-adult': 'Standard Adult',
  'hemodialysis': 'Hemodialysis',
  'cvvhd-crrt': 'CVVHD/CRRT',
  'peritoneal-dialysis': 'Peritoneal Dialysis',
  'obesity': 'Obesity',
  'elderly-high-risk': 'Elderly High-Risk',
  'augmented-renal-clearance': 'Augmented Renal Clearance',
  'neonatal-pediatric': 'Neonatal/Pediatric',
  'cystic-fibrosis': 'Cystic Fibrosis',
  'pregnancy': 'Pregnancy',
  'burns-ascites': 'Burns/Ascites',
};

const NOMOGRAM_LABELS: Record<string, string> = {
  'hartford': 'Hartford',
  'barnes-jewish': 'Barnes-Jewish',
  'urban-craig': 'Urban-Craig',
  'rochester': 'Rochester',
};

const LEVEL_TYPE_LABELS: Record<string, string> = {
  'peak': 'Peak',
  'trough': 'Trough',
  'random': 'Random',
  'mid-interval': 'Mid-Interval',
};

const RENAL_STABILITY_LABELS: Record<string, string> = {
  'stable': 'Stable',
  'unstable': 'Unstable',
};

export function indicationLabel(value: string): string {
  return INDICATION_LABELS[value] ?? value;
}

export function fluidStatusLabel(value: string): string {
  return FLUID_LABELS[value] ?? value;
}

export function populationLabel(value: string): string {
  return POPULATION_LABELS[value] ?? value;
}

export function nomogramLabel(value: string): string {
  return NOMOGRAM_LABELS[value] ?? value;
}

export function levelTypeLabel(value: string): string {
  return LEVEL_TYPE_LABELS[value] ?? value;
}

export function renalStabilityLabel(value: string): string {
  return RENAL_STABILITY_LABELS[value] ?? value;
}
